import React from 'react';
import { connect } from 'react-redux';

import { Page } from 'components/layout';
import { NavFooterList, NavFooterForm } from 'components/blocks/NavFooter';


const NavFooterListScreen = ({ history, site, navFooter, actions }) => {
  return (
    <Page
      title="Навигация"
      info={navFooter.filter.query ? `Найдено: ${navFooter.count}`: ""}
      modelActions={actions.brand}
      breadcrumbs={[
        { title: 'Сайт', path: '/site' },
        { title: 'Навигация', path: navFooter.urls.list() },
      ]}
      
      basePath="/site/nav"
      tabs={[
        { title: 'Главная навигация', key: 'detail' },
        { title: 'Верхняя навигация', key: 'top' },
        { title: 'Нижняя навигация', key: 'footer' },
      ]}
    >
      <div className="page-main">
        <NavFooterList />
      </div>

      <NavFooterForm />
    </Page>
  );
};

const mapState = (state) => ({
  site: state.site,
  navFooter: state.navFooter,
});

const mapDispatch = (dispatch) => ({
  actions: {
    navFooter: dispatch.navFooter,
  },
});

export default connect(mapState, mapDispatch)(NavFooterListScreen);
